module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-tokyo-4-284e4b0de9deb35549f1e39b36a8f779.jpg";